define([
	"dojo/_base/declare",
	"dojo/keys",
	"csi/heading/TextController",
	"csi/html",
	"csi/types",
	"src/c8-platform/type/value"
], function(declare,keys,TextController,html,types,{VALUE_TYPE}) {

	return declare(TextController, {
		_processKey: function(/*Event*/evt) {
			// summary: handle CTRL+(1-7) as fraction hotkeys
			if ((evt.ctrlKey || evt.metaKey) && (evt.keyCode >= 49) && (evt.keyCode <= 55)) {
				var	x = types.getFractionString((evt.keyCode-48)/8);
				var	v = this.editNode.get("value");
				var	p = (v && v.charAt(0) == "-") ? "-" : "";
				var	n = types.getInternalNumber(v);

				if (isNaN(n)) return true;

				if (n) {
					n = String(n).split(".")[0];

					if (Number(n)) {
						n += " " + x;
					} else {
						n = p + x;
					}
				} else {
					n = p + x;
				}

				this.editNode.set("value", n);
				html.setCursorPosition(this.editNode);
				return true;
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * hook up fromHTMLDynamic to handle customization in inherited number renderers and controllers
		 * for instance, this allow to initialize value in special situations like Size chart, when empty value should be replaced with -999 and helping with fractions
		 */
		_processValue: function() {
			// processing the value handles number separator conversion and other cases such as fractions.
			const processedValue = this._fromHtmlDynamicGuarded();
			// processed value may be 0 (not string but number 0), be careful when evaluating: only assign back to this.newValue if processed value is really undefined
			this.newValue =  processedValue === undefined ? this.newValue : processedValue;
			this.inherited(arguments);
		},

		_isPositiveValue: function() {
			// summary: return whether or not value entered was explicity set as positive
			var v = this.reactLastInput || this.getInlineEditValue();
			return v && (v.charAt?.(0) == '+');
		},

		_isValueChanged: function() {
			// summary: compare displayed values rather than stored values - better handles fractions and formatted numbers;
			// if invalid entry, then return true here and let validation handle the rest
			if (isNaN(this.oldValue) || isNaN(this.newValue)) {
				return true;
			}

			// if number is an integer, check if newValue value is not an integer, then return true here and let validation handle the rest
			if (this.ren.type === VALUE_TYPE.INTEGER && !Number.isInteger(this.newValue)) {
				return true;
			}

			var	v1 = this.ren.toValueDynamic(this._ctx, this.heading, this.oldValue);
			var	v2 = this.ren.toValueDynamic(this._ctx, this.heading, this.newValue);
			return v1 != v2;
		},

		_getEditNodeStyles: function(/*Number*/w, /*Number*/h, /*Number?*/ minWidth) {
			// summary: set width of widget to that of refNode with default minimum
			return {
				minWidth: minWidth ? minWidth : "40px",
				width: w + "px",
				height: "25px",
				minHeight: "25px"
			};
		},
	});
});